import React from 'react'

export default class NotFound extends React.Component {

    render() {
        return <div className="broadcast">
            <h1>Nothing to see here.</h1>
        </div>
        }
};



// WEBPACK FOOTER //
// ./src/components/not-found/index.js